import React from "react";
import { useSelector } from "react-redux";
import makeStyles from "@mui/styles/makeStyles";
import { Grid, Typography } from "@mui/material/";
import { strings } from "../../../../common/i18n";
import { format, helpers } from "../../../../common/lib";
import styles from "./styles";

const yesNo = (value: boolean) => strings(value ? "yes" : "no");

type Props = {
    branch: number,
    isExpected: boolean,
    isLive: boolean,
    location: number,
    createdDate: string,
    upload: any
};

/**
 * Alt-asset Auxiliary Detail Component
 */
export default ({
    branch,
    isExpected,
    isLive,
    location,
    createdDate,
    upload
}: Props) => {
    const { branches, locations } = useSelector((state) => state);

    const branchItem = helpers.getListItemForId(branches, branch);
    const locationItem = helpers.getListItemForId(locations, location);

    const firstSeen = format.dateTimeNew(createdDate);

    const classes = makeStyles(styles)();

    const makeColumn = (label: string, value: any) => (
        <Grid item xs={6}>
            <Typography
                variant="caption"
                className={classes.columnLabel}
            >{`${label} :`}</Typography>
            <Typography
                variant="body2"
                className={classes.columnText}
                title={value || "\u2014"}
            >
                {value || "\u2014"}
            </Typography>
        </Grid>
    );

    const ReturnFileData = () => {
        if (upload != null) {
            const strippedFileName = upload.originalFilename.split("/").pop();
            const lastSeen = format.dateTimeNew(upload.statusDate);

            return (
                <>
                    {makeColumn(strings("latestUpload"), lastSeen)}
                    {makeColumn(
                        strings("fileType"),
                        upload.uploadPickup.fileType.description
                    )}
                    {makeColumn(strings("fileName"), strippedFileName)}
                </>
            );
        } else {
            return (
                <>
                    {makeColumn(
                        strings("fileData"),
                        strings("messages.noFileData")
                    )}
                </>
            );
        }
    };

    return (
        <Grid container>
            {makeColumn(strings("branch"), branchItem.name)}
            {makeColumn(strings("location"), locationItem.name)}
            {makeColumn(strings("expected"), yesNo(isExpected))}
            {makeColumn(strings("live"), yesNo(isLive))}
            {makeColumn(strings("created"), firstSeen)}
            <ReturnFileData />
        </Grid>
    );
};
